import { ConfiguredOffer, GetOfferDetailsResponse } from "../../model/MortgageExtensionModel";
import HttpClient from "../http-client/HttpClient";

const MORTGAGE_OFFERS_ENDPOINT = "api/offer-details";
const OFFER_CONFIRMATION_ENDPOINT = "api/offer-confirmation";

export default class MortgageClient {
    httpClient: HttpClient;

    constructor(client: HttpClient) {
        this.httpClient = client;
    }

    async fetchMortgages(): Promise<GetOfferDetailsResponse> {
        const data = await this.httpClient.get(MORTGAGE_OFFERS_ENDPOINT);
        return data as GetOfferDetailsResponse;
    }

    async submitOffer(offer: ConfiguredOffer): Promise<void> {
        return await this.httpClient.post(offer, OFFER_CONFIRMATION_ENDPOINT);
    }
}
